export const SET_REGIONS = "SET_REGIONS";

export const setRegions = regions => {
  return {
    type: SET_REGIONS,
    regions: regions
  };
};
